const userId = user => String(user?.userId || user?.tmAuthUserId || user?.id || user?._id || '');

export const isDebaterSegment = segment =>
  /^(debaters?|debators?|speakers?|pro|con)(?:\s|$)/i.test(String(segment?.role || '').trim());

const splitLimit = (value, count) => {
  const match = String(value || '').trim().match(/^(\d+)(?::(\d{1,2}))?$/);
  if (!match || Number(match[2] || 0) >= 60) return '';
  const seconds = Math.floor((Number(match[1]) * 60 + Number(match[2] || 0)) / count);
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
};

export function getDebateTurns(activity, moderator) {
  const sides = Object.fromEntries(['pro', 'con'].map(side => [
    side, (activity?.sides?.[side] || []).filter(user => userId(user)),
  ]));
  const groupedDebaters =
    ['pro', 'con'].flatMap(side => sides[side].map(speaker => ({ side, speaker })));
  const alternatingDebaters =
    Array.from({ length: Math.max(sides.pro.length, sides.con.length) }, (_, index) =>
      ['pro', 'con'].flatMap(side => sides[side][index] ? [{ side, speaker: sides[side][index] }] : [])).flat();
  return (activity?.segments || []).flatMap((segment, segmentIndex) => {
    const base = { ...segment, segmentIndex, sourceSegmentId: segment.id };
    if (activity.type !== 'debate') return [base];
    if (/^moderator$/i.test(String(segment.role || '').trim())) return [{ ...base, speaker: moderator }];
    if (!isDebaterSegment(segment)) return [base];
    const debaters = (segment.speakingOrder || activity.speakingOrder) === 'grouped'
      ? groupedDebaters : alternatingDebaters;
    if (!debaters.length) return [{ ...base, speaker: null, requiresDebaters: true, timer: null }];
    const limits = Object.fromEntries(['green', 'amber', 'red', 'total'].map(field => [
      field, splitLimit(segment[field], debaters.length),
    ]));
    return debaters.map(({ speaker, side }, turnIndex) => {
      // Identity-based IDs preserve each speaker's recording when speaking order changes.
      const id = `${segment.id}::${side}::${encodeURIComponent(userId(speaker))}`;
      return {
        ...base, ...limits, id, speaker, side, turnIndex, turnCount: debaters.length,
        timer: (activity.turnTimers || []).find(timer => timer.segmentId === id) || null,
      };
    });
  });
}
